import { createSelector, Selector } from '@reduxjs/toolkit'
import { EntityType, FatFingerDetail, ProductSectorAggregate } from 'api'
import { GlobalState } from 'store'
import { createAllEntityUpdatesSelector, createEntityGetterSelector, createSortedEntityIdsSelector } from './entitySelectors'
import { allKnownSortedProductSectorIdsSelector } from './productSelectors'

export const fatFingerDetailsSelector: Selector<GlobalState, FatFingerDetail[]> = createSelector(
  createAllEntityUpdatesSelector(EntityType.FAT_FINGER_PRODUCT_SECTOR),
  createEntityGetterSelector(EntityType.PRODUCT_SECTOR),
  createEntityGetterSelector(EntityType.PRODUCT),
  (fatFingerUpdates, getProductSector, getProduct) => {
    return fatFingerUpdates.map(update => {
      const fatFinger = update.entity
      const productSector = getProductSector(update.entity.productSectorId)
      const product = productSector && getProduct(productSector.productId)
      const availableEvents = update.availableEvents

      return { fatFinger, productSector, product, availableEvents }
    })
  }
)

export const sectorIdsWithoutFatFingerLimitSelector = createSelector(
  [allKnownSortedProductSectorIdsSelector, createSortedEntityIdsSelector(EntityType.FAT_FINGER_PRODUCT_SECTOR)],
  (productSectorIds, fatFingerLimitIds) => {
    return productSectorIds.filter(productSectorId => !fatFingerLimitIds.includes(productSectorId))
  }
)

export const createProductSectorAggregateGetterSelector: Selector<
  GlobalState,
  (productSectorId: string) => ProductSectorAggregate
> = createSelector(
  createEntityGetterSelector(EntityType.PRODUCT_SECTOR),
  createEntityGetterSelector(EntityType.PRODUCT),
  (getProductSector, getProduct) => (productSectorId: string) => {
    const productSector = getProductSector(productSectorId)
    const product = productSector && getProduct(productSector.productId)
    return { productSector, product }
  }
)
